<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span><el-page-header content="队伍锦标赛" @back="goBack" /></span>
          <el-card style="margin-top: 10px;">
            <div slot="header" class="clearfix">
              <el-row :gutter="10">
                <CommonExcel
                  ref="CommonExcelRef"
                  :import-p="'config:rewardRankEdit:import'"
                  :export-p="'config:rewardRankEdit:export'"
                  :import-method="importBaseCfg"
                  :export-method="exportBaseCfg"
                />
              </el-row>
            </div>
            <el-table size="mini" :data="baseList" border style="width: 100%;min-height: 100px;" highlight-current-row>
              <el-table-column align="center" label="序号" width="50">
                <template v-slot:default="{row, $index}">
                  <span style="display:block">{{ $index+1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="参与数量" align="center">
                <template v-slot:default="scope">
                  <el-input v-model.number="scope.row.joinNum" style="width: 250px;" placeholder="参与数量" />
                </template>
              </el-table-column>
              <el-table-column label="个人奖励" align="center">
                <template v-slot:default="scope">
                  <el-select v-model="scope.row.stageId">
                    <el-option v-for="item in list[1]" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="名次奖励" align="center">
                <template v-slot:default="scope">
                  <el-select v-model="scope.row.rankId">
                    <el-option v-for="item in list[2]" :key="item.id" :value="item.id" :label="item.name" />
                  </el-select>
                </template>
              </el-table-column>
              <!--              <el-table-column label="操作" align="center" width="100">-->
              <!--                <template v-slot:default="{row,$index}">-->
              <!--                  <el-button v-permisaction="['config:rewardRankEdit:del']" size="mini" type="danger" @click="deleteBaseConfig($index)">删除</el-button>-->
              <!--                </template>-->
              <!--              </el-table-column>-->
            </el-table>
            <div style="float:left;margin-top: 1rem">
              <el-button v-permisaction="['config:rewardRankEdit:add']" :disabled="baseList.length > 0" type="primary" size="mini" @click="addBaseConfig()">新增</el-button>
              <el-button v-permisaction="['config:rewardRankEdit:add']" type="primary" :disabled="isOnline === 1" size="mini" style="margin:10px 10px" @click="handleSaveBase()">保存</el-button>
            </div>
          </el-card>
        </div>
      </el-card>
      <el-card style="margin-top: 20px">
        <div slot="header" class="clearfix">
          <span>玩家分池/分组</span>
          <el-row :gutter="10">
            <el-row :gutter="10">
              <CommonExcel
                ref="CommonExcelRef2"
                :import-p="'config:rewardTwoPlusGiftEdit:import'"
                :export-p="'config:rewardTwoPlusGiftEdit:export'"
                :import-method="importBaseCfg2"
                :export-method="exportBaseCfg2"
              />
            </el-row>
          </el-row>
        </div>
        <el-form>
          <!--          <el-form-item label="分区类型" style="margin-top: 10px;">-->
          <!--            <el-select v-model.number="vipSet.setType" placeholder="请选择">-->
          <!--              <el-option-->
          <!--                v-for="item in vipType"-->
          <!--                :key="item.value"-->
          <!--                :label="item.label"-->
          <!--                :value="item.value"-->
          <!--              />-->
          <!--            </el-select>-->
          <!--          </el-form-item>-->
          <el-form-item v-if="vipSet.setType === 2" label="星星分块" style="margin-top: 10px;">
            <el-input v-for="(v,k) in vipSet.spinsSet" :key="k" v-model.number="vipSet.spinsSet[k]" style="width: 130px;margin-left: 10px" placeholder="体力分块" />
          </el-form-item>
          <el-form-item v-if="vipSet.setType === 2" label="停止区间" style="margin-top: 10px;">
            <el-input v-for="(v,k) in vipSet.spinsSetSpins" :key="k" v-model.number="vipSet.spinsSetSpins[k]" style="width: 130px;margin-left: 10px" placeholder="体力分块" />
          </el-form-item>
          <el-form-item v-if="vipSet.setType === 1" label="vip分块" style="margin-top: 10px;">
            <el-input v-for="(v,k) in vipSet.vipSet" :key="k" v-model.number="vipSet.vipSet[k]" style="width: 130px;margin-left: 10px" placeholder="vip分块" />
          </el-form-item>
          <el-form-item v-if="vipSet.setType === 1" label="vip区间" style="margin-top: 10px;">
            <el-input v-for="(v,k) in vipSet.vipSetSpins" :key="k" v-model.number="vipSet.vipSetSpins[k]" style="width: 130px;margin-left: 10px" placeholder="vip分块" />
          </el-form-item>
          <el-button v-permisaction="['config:rewardRankEdit:add']" size="mini" :disabled="isOnline === 1" type="primary" @click="onSubmitVipSet()">保存</el-button>
        </el-form>
      </el-card>
      <el-card style="margin-top: 20px">
        <div slot="header" class="clearfix">
          <span>机器人配置</span>
          <el-row :gutter="10">
            <el-row :gutter="10">
              <CommonExcel
                ref="CommonExcelRef2"
                :import-p="'config:rewardTwoPlusGiftEdit:import'"
                :export-p="'config:rewardTwoPlusGiftEdit:export'"
                :import-method="importBaseCfg3"
                :export-method="exportBaseCfg3"
              />
            </el-row>
          </el-row>
        </div>
        <el-row v-for="(item, index) in vipSet.robot" :key="index">
          <el-form :inline="true">
            <el-form-item label="机器人ID">
              <el-input v-model.number="item.id" style="width: 130px;" placeholder="机器人ID" />
            </el-form-item>
            <el-form-item label="获得收集物数量">
              <el-input v-model.trim="item.co1" style="width: 80px;" placeholder="获得收集物数量" />
            </el-form-item>
            <el-form-item label="-">
              <el-input v-model.trim="item.co2" style="width: 80px;" placeholder="获得收集物数量" />
            </el-form-item>
            <el-form-item label="初始系值">
              <el-input v-model.number="item.pro" style="width: 80px;" placeholder="初始系值" />
            </el-form-item>
            <el-form-item label="停止目标值">
              <el-input v-model.number="item.num" style="width: 80px;" placeholder="停止目标值" />
            </el-form-item>
            <el-form-item>
              <el-button v-permisaction="['config:rewardRankEdit:del']" type="danger" size="mini" @click="delBot(index)">删除</el-button>
            </el-form-item>
          </el-form>
        </el-row>
        <el-button v-permisaction="['config:rewardRankEdit:del']" size="mini" type="primary" @click="addBot()">+</el-button>
        <el-button v-permisaction="['config:rewardRankEdit:add']" size="mini" :disabled="isOnline === 1" type="primary" @click="onSubmitVipSet()">保存</el-button>
      </el-card>
      <el-card style="margin-top: 20px">
        <div slot="header" class="clearfix">
          <span>机器人人数限制</span>
          <el-row :gutter="10">
            <el-row :gutter="10">
              <CommonExcel
                ref="CommonExcelRef2"
                :import-method="importBaseCfg4"
                :export-method="exportBaseCfg4"
              />
            </el-row>
          </el-row>
        </div>
        <el-form :inline="true">
          <el-row v-for="(item, index) in vipSet.rankLimit" :key="index">
            <el-form-item label="剩余小时数">
              <el-input v-model.number="item.time" style="width: 130px;margin-left: 10px" placeholder="剩余小时数" />
            </el-form-item>
            <el-form-item label="房间人数">
              <el-input v-model.number="item.limit" style="width: 130px;margin-left: 10px" placeholder="房间人数" />
            </el-form-item>
            <el-form-item>
              <el-button v-permisaction="['config:rewardRankEdit:del']" type="danger" size="mini" @click="delRankLimit(index)">删除</el-button>
            </el-form-item>
          </el-row>
          <el-form-item style="margin-top: 10px;">
            <el-button v-permisaction="['config:rewardRankEdit:add']" type="primary" size="mini" @click="addRankLimit()">+</el-button>
          </el-form-item>
        </el-form>
        <el-button v-permisaction="['config:rewardRankEdit:add']" size="mini" :disabled="isOnline === 1" type="primary" @click="onSubmitVipSet()">保存</el-button>
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getUserTypeAllList } from '@/api/config/user-group-cfg'
import { actAuxiliary } from '@/api/config/activity-auxiliary-cfg'
import {
  getActivityList,
  updateActivityExtraData,
  updateActivityProData
} from '@/api/config/activity-cfg'
import CommonExcel from '@/components/CommonExcel/index.vue'
import { downloadExcelMultiSheet } from '@/utils/excel'

export default {
  name: 'RewardClubRankEdit',
  components: { CommonExcel },
  data() {
    return {
      vipType: [
        {
          'value': 2,
          'label': '体力'
        }
        // {
        //   'value': 1,
        //   'label': 'vip积分'
        // }
      ],
      vipSet: {
        setType: 2,
        vipSet: [0, 0, 0, 0, 0, 0],
        spinsSet: [0, 0, 0, 0, 0, 0, 0, 0, 0],
        vipSetSpins: [0, 0, 0, 0, 0, 0],
        spinsSetSpins: [0, 0, 0, 0, 0, 0, 0, 0, 0],
        robot: [{ id: 1, pro: 0, num: 1, co1: 1, co2: 1 }],
        rankLimit: [
          { time: 1, limit: 1 }
        ]
      },
      list: [],
      baseList: [],
      groupsList: [{ name: '默认分组', id: 0 }],
      curClass: 'club_rank',
      rewardConf: [],
      shopSku: [],
      isOnline: 0
    }
  },
  created() {
    this.aid = this.$route.query.id
    this.actType = this.$route.query.type
    this.curClass = this.$route.query.type
    this.ucType = this.$route.query.uc_type
    this.isOnline = parseInt(this.$route.query.is_online)
    this.init()
  },
  methods: {
    init() {
      this.getActivity()
      this.getList()
      this.initBase()
    },
    initBase() {
      getUserTypeAllList().then(res => {
        res.data.forEach(res => {
          this.groupsList.push({ name: res.name, id: res.groupId })
        })
      })
    },
    getList() {
      this.loading = true
      actAuxiliary({ class: this.curClass, select: 0 }).then(response => {
        this.list = response.data
        for (const key in this.typeArr) {
          if (this.list[key] === undefined || this.list[key] == null) {
            this.list[key] = []
          }
        }
        this.loading = false
      })
    },
    addBaseConfig() {
      this.baseList.push({ minLv: 1, maxLv: 999, groupIds: [], stageCoefficientId: 0, stageId: 0, rankId: 0 })
    },
    deleteBaseConfig(index) {
      this.baseList.splice(index, 1)
    },
    handleSaveBase() {
      if (this.baseList.length === 0) {
        this.msgError('请先添加数据')
        return
      }
      const _baseList = this.baseList[0]
      const data = JSON.stringify(_baseList)
      updateActivityProData({ name: this.aid, data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getActivity()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getActivity() {
      getActivityList({ id: this.aid }).then(res => {
        if (res.code === 200) {
          this.baseList = [res.data.list[0].reward_pro]

          const extra = res.data.list[0].extraData
          const robot = []
          for (const i in extra.robot) {
            robot.push(extra.robot[i])
          }
          delete extra.robot
          extra.robot = robot
          if (!extra.setType) {
            extra.setType = 1
          }
          if (!extra.spinsSet) {
            extra.spinsSet = this.vipSet.spinsSet
          }
          if (!extra.spinsSetSpins) {
            extra.spinsSetSpins = this.vipSet.spinsSetSpins
          }
          if (!extra.vipSet) {
            extra.vipSet = this.vipSet.vipSet
          }
          if (!extra.vipSetSpins) {
            extra.vipSetSpins = this.vipSet.vipSetSpins
          }

          this.vipSet = extra
        }
      })
    },
    goBack() {
      this.$router.push({ path: '/config/activity-config/index' })
    },
    importBaseCfg(excelInfo) {
      const excelData = excelInfo.data
      for (let i = 0; i < excelData.length; i++) {
        this.baseList = this.$refs.CommonExcelRef.tranToTarget(excelData[i].sheetData, { groupIds: this.groupsList, rewardId: this.list[2] }, true, 'name', 'id')
        break
      }
    },
    importBaseCfg2(excelInfo) {
      const excelData = excelInfo.data
      this.vipSet.setType = 1
      for (let i = 0; i < excelData.length; i++) {
        if (excelData[i].sheetName === '体力分块') {
          this.vipSet.setType = 2
        }
        const tempValArr = []
        const val = this.$refs.CommonExcelRef2.tranToTarget(excelData[i].sheetData, { }, true, 'name', 'id')
        switch (this.vipSet.setType) {
          case 1:
            for (const k in val[0]) {
              tempValArr.push(val[0][k])
            }
            if (i === 0) {
              this.vipSet.vipSet = tempValArr
            } else {
              this.vipSet.vipSetSpins = tempValArr
            }
            break

          case 2:
            for (const k in val[0]) {
              tempValArr.push(val[0][k])
            }
            if (i === 0) {
              this.vipSet.spinsSet = tempValArr
            } else {
              this.vipSet.spinsSetSpins = tempValArr
            }
            break
        }
      }
    },
    exportBaseCfg2() {
      this.exportBaseCfg('vip')
    },
    exportBaseCfg3() {
      this.exportBaseCfg('robotConfig')
    },
    exportBaseCfg4() {
      this.exportBaseCfg('robotLimit')
    },
    importBaseCfg3(excelInfo) {
      const excelData = excelInfo.data
      this.vipSet.robot = this.$refs.CommonExcelRef.tranToTarget(excelData[0].sheetData, { }, true, 'name', 'id')
    },
    importBaseCfg4(excelInfo) {
      const excelData = excelInfo.data
      this.vipSet.rankLimit = this.$refs.CommonExcelRef.tranToTarget(excelData[0].sheetData, { }, true, 'name', 'id')
    },
    exportBaseCfg(type) {
      let fileName = '锦标赛配置'
      const hearer = []
      const excelData = []
      let name = ['锦标赛配置']
      let data = {}
      let tranTitle = {}
      let listArr = []
      if (type === 'vip') {
        data = {}
        fileName = '玩家分池分组'
        name = ['星星分块', '停止区间']
        const arr = []
        const type = this.vipSet.setType
        const keys = {
          1: { 'vipSet': 'vip分块', 'vipSetSpins': 'vip区间' },
          2: { 'spinsSet': '星星分块', 'spinsSetSpins': '停止区间' }
        }
        const key = keys[type]
        for (const k in key) {
          const tempObj = { k: [], v: {}}
          const temp = {}
          for (const i in this.vipSet[k]) {
            temp[k + i] = this.vipSet[k][i]
            tempObj['v'][k + i] = key[k] + i
          }
          tempObj['k'].push(temp)
          arr.push(tempObj)
        }
        for (const i in arr) {
          const val = arr[i]
          const list = this.$refs.CommonExcelRef.tranToTarget(val.k, data, true, 'id', 'name')
          const tAk = this.$refs.CommonExcelRef.makeExcelData(list, val.v)
          hearer.push(tAk[0])
          excelData.push(tAk[1])
        }
        downloadExcelMultiSheet(this.$route.meta.title + fileName, name, hearer, excelData)
        return
      }
      switch (type) {
        case 'robotConfig':
          fileName = '机器人配置'
          data = {}
          tranTitle = { id: '机器人ID', co1: '获得收集物数量-最小值', co2: '获得收集物数量-最大值', pro: '初始系值', num: '停止目标值' }
          listArr = this.vipSet.robot
          break

        case 'robotLimit':
          fileName = '机器人人数限制'
          data = {}
          tranTitle = { time: '剩余小时数', limit: '房间人数' }
          listArr = this.vipSet.rankLimit
          break

        default:
          listArr = this.baseList
          data = { stageId: this.list[1], rankId: this.list[2] }
          tranTitle = { joinNum: '参与数量', stageId: '进度奖励配置', rankId: '排行榜奖励配置' }
          break
      }
      const list = this.$refs.CommonExcelRef.tranToTarget(listArr, data, true, 'id', 'name')
      const tAk = this.$refs.CommonExcelRef.makeExcelData(list, tranTitle)
      hearer.push(tAk[0])
      excelData.push(tAk[1])
      downloadExcelMultiSheet(this.$route.meta.title + fileName, name, hearer, excelData)
    },
    onSubmitVipSet() {
      const robotJson = {}
      const postData = this.vipSet
      for (const i in postData) {
        if (i === 'robot') {
          let idx = 1
          const robot = postData[i]
          robot.forEach((item, index) => {
            if (idx > 10) {
              idx = 49
            }
            postData[i][index].co1 = parseFloat(item.co1)
            postData[i][index].co2 = parseFloat(item.co2)
            postData[i][index].id = idx
            robotJson[idx.toString()] = item
            idx++
          })
        }
      }
      postData.robot = robotJson
      const data = JSON.stringify(postData)
      updateActivityExtraData({ name: this.aid, data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getActivity()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    delBot(index) {
      this.vipSet.robot = this.vipSet.robot.filter((item, i) => {
        return index !== i
      })
      let id = 0
      this.vipSet.robot.forEach((item, index) => {
        id++
        this.vipSet.robot[index].id = id
      })
    },
    addBot() {
      const len = this.vipSet.robot.length
      if (len >= 12) {
        this.msgError('最多添加12个机器人')
        return
      }
      this.vipSet.robot.push({
        id: len + 1,
        pro: 0,
        num: 0,
        co1: 0,
        co2: 0
      })
    },
    addRankLimit(index) {
      if (!this.vipSet.rankLimit) {
        this.vipSet.rankLimit = []
      }
      this.vipSet.rankLimit.push({ time: 1, limit: 1 })
    },
    delRankLimit(index) {
      this.vipSet.rankLimit = this.vipSet.rankLimit.filter((item, i) => {
        return index !== i
      })
    }
  }
}
</script>

<style scoped>
</style>
